import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { HeroHomeSlide as Original } from 'components/molecules'
import { HeroHomeSlideSettings } from './HeroHomeSlideSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import {
  ctaDefaultProps,
  ctaItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/CtaToolbarSection'
import {
  imageDefaultProps,
  imageItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ImageToolbarSection'
import { getTextEditor } from '../TextEditor'
import { getAncestorNodeByName } from 'react-pagebuilder/utils/node'
import {
  videoDefaultProps,
  videoItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/VideoToolbarSection'

export const defaultProps = {
  ...ctaDefaultProps(),
  ...videoDefaultProps(['autoplay', 'muted', 'loop', 'controls', 'related']),
  ...imageDefaultProps(),
}

export const heroHomeSlideItemParams = (enabled, id, blockProps, children) => ({
  ...videoItemParams(blockProps),
  ...imageItemParams(blockProps),
  ...ctaItemParams(blockProps, enabled),
  pk: id,
  name: getTextEditor(children?.[0], enabled),
  ctaLabel: getTextEditor(children?.[1], enabled),
})

export const dynamicProps = []

export const HeroHomeSlide: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled, parentBlock } = useEditor(
      (state, query) => ({
        enabled: state.options.enabled,
        parentBlock: getAncestorNodeByName(id, query, 'HeroHome')?.data?.props?.block,
      }),
      props
    )

    return (
      <div ref={(ref) => props.retRef(ref)} className={`block-hero-home-slide ${props.className}`}>
        <Original
          item={heroHomeSlideItemParams(enabled, id, blockProps, children)}
          editMode={enabled}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

HeroHomeSlide.craft = withCraft({
  name: 'HeroHomeSlide',
  defaultProps: defaultProps,
  settings: HeroHomeSlideSettings,
})
